import Button from 'react-bootstrap/Button'
import ProgressBar from 'react-bootstrap/ProgressBar'
import Stack from 'react-bootstrap/Stack'

import { QuestionPageProps } from '../Types'

export function QuestionPage({questionTitle, answers, onClick, progressRate, progressLabel} : QuestionPageProps) {
    return (
        <>
            <h3>{questionTitle}</h3>
            <ProgressBar now={progressRate} label={progressLabel} style={{ maxWidth: "500px" }} /><br />
            <Stack gap={2} style={{ maxWidth: "500px" }}>
                {answers.map(({ value, title }) => (<Button value={value} onClick={onClick} key={value}>{title}</Button>))}
            </Stack>
        </>
    )
}